export const NAV = {
  logo: "nav-logo",
  about: "nav-link-about",
  services: "nav-link-services",
  how: "nav-link-how-it-works",
  booking: "nav-link-booking",
  contact: "nav-link-contact",
  ctaBook: "nav-cta-book",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  heading: "hero-heading",
  subheading: "hero-subheading",
  ctaBook: "hero-cta-book",
  ctaLearn: "hero-cta-learn",
  badge: "hero-badge",
};

export const ABOUT = {
  section: "about-section",
  yearsBadge: "about-years-badge",
  warrantyBadge: "about-warranty-badge",
  jobsBadge: "about-jobs-badge",
};

export const SERVICES = {
  section: "services-section",
  showers: "service-card-showers",
  conservatories: "service-card-conservatories",
  windows: "service-card-windows",
  bespoke: "service-card-bespoke",
};

export const HOWITWORKS = {
  section: "how-it-works-section",
  step1: "how-step-1",
  step2: "how-step-2",
  step3: "how-step-3",
  step4: "how-step-4",
};

export const BOOKING = {
  section: "booking-section",
  calendar: "booking-calendar",
  selectedDate: "booking-selected-date",
  name: "booking-input-name",
  email: "booking-input-email",
  phone: "booking-input-phone",
  address: "booking-input-address",
  glassType: "booking-select-glass-type",
  notes: "booking-input-notes",
  submit: "booking-submit-button",
  success: "booking-success-message",
  error: "booking-error-message",
};

export const FAQ = {
  section: "faq-section",
  item: (i) => `faq-item-${i}`,
};

export const CONTACT = {
  section: "contact-section",
  name: "contact-input-name",
  email: "contact-input-email",
  message: "contact-input-message",
  submit: "contact-submit-button",
  success: "contact-success-message",
  phone: "contact-phone",
  emailLink: "contact-email",
};

export const FOOTER = {
  root: "site-footer",
};
